let config = null;

export async function loadConfig() {
  if (config) return config; // in-memory is fine

  let cachedConfig = null;
  const cached = localStorage.getItem('app_config');
  if (cached) {
    try {
      cachedConfig = JSON.parse(cached);
    } catch {
      localStorage.removeItem('app_config');
    }
  }

  try {
    const res = await fetch('/config.json');
    if (!res.ok) throw new Error(`Failed to load config.json: ${res.status}`);
    const freshConfig = await res.json();

    if (!freshConfig.baseUrl) throw new Error('Config is missing baseUrl');

    // Always fetch provider data fresh
    try {
      const providerRes = await fetch(`${freshConfig.baseUrl}/internal/provider-data`);
      if (!providerRes.ok) throw new Error(`Provider data fetch failed: ${providerRes.status}`);
      const providers = await providerRes.json();
      providers?.data?.forEach(({ provider, platform, config: cfg }) => {
        if (!cfg) return;
        if (provider === 'MICROSOFT') {
          freshConfig.azureClientId = cfg.client_id;
          freshConfig.azureTenantId = cfg.tenant_id;
        } else if (provider === 'GOOGLE' && platform === 'WEB') {
          freshConfig.googleClientId = cfg.client_id;
        }
      });
    } catch (err) {
      console.error('Failed to load provider data:', err);
      // If provider fetch fails, still use freshConfig (without OAuth IDs)
    }

    config = freshConfig;
    localStorage.setItem('app_config', JSON.stringify(config));
  } catch (err) {
    if (!cachedConfig) throw err;
    config = cachedConfig;
  }

  return config;
}

export function getConfig() {
  if (!config) throw new Error('Config not loaded. Call loadConfig() first.');
  return config;
}
